var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5105_3967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.546 6.95883V4.41012C12.3369 4.41012 11.4142 4.09153 10.8187 3.4723C10.2076 2.76559 9.86519 1.87062 9.85054 0.941527V0.757552L7.40963 0.699219V11.0511C7.3259 11.5028 7.1038 11.9182 6.77333 12.2413C6.44285 12.5644 6.01991 12.7797 5.5616 12.858C5.10328 12.9363 4.63167 12.8739 4.21042 12.6792C3.78917 12.4845 3.43857 12.1669 3.20595 11.7693C2.97333 11.3717 2.86989 10.9132 2.9096 10.4557C2.9493 9.99824 3.13024 9.5638 3.42799 9.21104C3.72573 8.85829 4.12595 8.60421 4.57461 8.48311C5.02326 8.362 5.49876 8.37971 5.9369 8.53383V6.06589C5.68144 6.02456 5.42303 6.00356 5.16417 6.00306C4.2328 6.00306 3.32235 6.27571 2.54794 6.78652C1.77353 7.29732 1.16996 8.02335 0.813538 8.8728C0.457118 9.72224 0.363863 10.6569 0.545564 11.5587C0.727265 12.4605 1.17576 13.2888 1.83434 13.9389C2.49292 14.5891 3.332 15.0318 4.24547 15.2112C5.15895 15.3905 6.10579 15.2985 6.96626 14.9466C7.82674 14.5948 8.5622 13.9989 9.07964 13.2345C9.59708 12.47 9.87326 11.5712 9.87326 10.6518C9.87276 10.4613 9.86061 10.271 9.8369 10.0819V5.97614C10.9468 6.66041 12.2382 7.00254 13.546 6.95883Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5105_3967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 15.5556,
    fill: "white",
    transform: "translate(0.333984 0.222656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtIcon);
export default __webpack_public_path__ + "static/media/tt-icon.08e81a7f1ea6668b812b79129c3d5913.svg";
export { ForwardRef as ReactComponent };